const setTollFreeData = function (state, data: any) {
  state.tollFreeStatus = data
  state.tollFreeStatusTracker = crypto.randomUUID()
}

export default setTollFreeData
